import React, { useEffect, useRef, useState } from 'react';
import { StatsService } from '../Services/StatsService';
import { Card, Row, Col, Table, CardBody, CardHeader, FormGroup, Input, Label, Button } from 'reactstrap';
import { withTranslation} from 'react-multi-lang';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Stock from './Stock';
import AllVolumes from './AllVolumes';

const Stats = ({t}) => {
    const statsService = new StatsService();
    const [volumesPerSelf, setVolumesPerSelf] = useState([]);
    const [volumesPerDateAndSelf, setVolumesPerDateAndSelf] = useState([]);
    const [avgVW, setAvgVW] = useState([]);
    const [filterDateFromvs, setFilterDateFromvs] = useState(null);
    const [filterDateTovs, setFilterDateTovs] = useState(null);
    const [filterDateFromvs2, setFilterDateFromvs2] = useState(null);
    const [filterDateTovs2, setFilterDateTovs2] = useState(null);
    const [filterDateFromws, setFilterDateFromws] = useState(null);
    const [filterDateTows, setFilterDateTows] = useState(null);
    const [unassessed, setUnassessed] = useState([]);

    useEffect(() => {
        updateAll();
    }, []);
    const vsRef = useRef(null);
    const wsRef = useRef(null);
    const unassessedRef = useRef(null);

    const updateAll = () => {
        updateVs();
        updateVs2();
        updateWs();
        updateUnassessed();
    }

    const updateVs = () => {
        statsService.getVolumesPerShelf(filterDateFromvs, filterDateTovs).then(r => {
            setVolumesPerSelf(r);
        });
    }
    
    const updateVs2 = () => {
        statsService.getVolumesPerDateAndShelf(filterDateFromvs2, filterDateTovs2).then(r => {
            setVolumesPerDateAndSelf(r);
        });
    }

    const updateWs = () => {
        statsService.getAverageWeightAndVolumePerShelf(filterDateFromws, filterDateTows).then(r => {
            setAvgVW(r);
        });
    }

    const updateUnassessed = () => {
        statsService.getUnAssessedVolumes().then(r => {
            setUnassessed(r);
        });
    }

    return <Card className="ps-5 pe-5 pt-5 pb-5">
        <Row>
            <Col md="12">
                <Button block color="warning" size="lg" onClick={updateAll}>{t('refresh')}</Button>
                <hr />
            </Col>
        </Row>
        <Row>
            <Col md="12">
                <Card>
                    <CardHeader className="bg-info">
                        <h3>Μη Αξιολογημένοι όγκοι</h3>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md="6">

                            </Col>
                            <Col md="6" className="d-grid gap-2">
                                <ReactHTMLTableToExcel
                                    id="unassessedButton"
                                    className="btn btn-success btn-block"
                                    table="unassessedTable"
                                    filename="unassessedVolumes"
                                    sheet="volumes"
                                    buttonText="Excel"/>
                            </Col>
                        </Row>
                        <Table responsive id="unassessedTable">
                            <thead>
                                <tr className="bg-warning">
                                    <th>Πατάρι</th>
                                    <th>Αριθμός Όγκων</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    unassessed.map((a, i) => {
                                        return <tr key={i}>
                                            <td>{a.self}</td>
                                            <td>{a.numVolumes}</td>
                                        </tr>
                                    })
                                }
                                <tr>
                                    <th>Σύνολο</th>
                                    <td>{unassessed.reduce((numUnassessed, u) => numUnassessed + parseInt(u.numVolumes), 0)}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
                <hr />
            </Col>
            <Col md="12">
                <Card>
                    <CardHeader className="bg-info">
                        <h3>Όγκοι / Πατάρι</h3>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md="6">
                                <Label>{t('from')}</Label>
                                <Input size="sm" type="date" placeholder={t('from')} onChange={(e) => setFilterDateFromvs(e.target.valueAsDate)} />
                            </Col>
                            <Col md="6">
                                <Label>{t('to')}</Label>
                                <Input size="sm" type="date" placeholder={t('to')} onChange={(e) => setFilterDateTovs(e.target.valueAsDate)} />
                            </Col>
                            <Col md="6">
                                <Button block color="primary" onClick={updateVs}>{t('search')}</Button>
                            </Col>
                            <Col md="6" className="d-grid gap-2">
                                <ReactHTMLTableToExcel
                                    id="vsButton"
                                    className="btn btn-success btn-block"
                                    table="vsTable"
                                    filename="volumesPerSelf"
                                    sheet="volumes"
                                    buttonText="Excel"/>
                            </Col>
                            <Col md="12">
                                <hr />
                            </Col>
                        </Row>
                        <Table responsive id="vsTable">
                            <thead>
                                <tr className="bg-warning">
                                    <th>Πατάρι</th>
                                    <th>Αριθμός Όγκων</th>
                                    <th>Μ.Ο. Μήκους</th>
                                    <th>Μ.Ο. Πλάτους</th>
                                    <th>Μ.Ο. Ύψους</th>
                                    <th>Μ.Ο.Όγκου</th>
                                    <th>Μ.Ο. Βάρους</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    volumesPerSelf.map((a, i) => {
                                        return <tr key={i}>
                                            <td>{a.self}</td>
                                            <td>{a.numVolumes}</td>
                                            <td>{a.length.toFixed(2)}</td>
                                            <td>{a.width.toFixed(2)}</td>
                                            <td>{a.height.toFixed(2)}</td>
                                            <td>{a.vol.toFixed(2)}</td>
                                            <td>{a.weight.toFixed(2)}</td>
                                        </tr>
                                    })
                                }
                                <tr>
                                    <th>Σύνολο</th>
                                    <td>{volumesPerSelf.reduce((numVols, u) => numVols + parseInt(u.numVolumes), 0)}</td>
                                    
                                </tr>
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
                <hr />
            </Col>
            <Col md="12">
                <Card>
                    <CardHeader className="bg-info">
                        <h3>Όγκοι / Πατάρι / Ημερομηνία</h3>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md="6">
                                <Label>{t('from')}</Label>
                                <Input size="sm" type="date" placeholder={t('from')} onChange={(e) => setFilterDateFromvs2(e.target.valueAsDate)} />
                            </Col>
                            <Col md="6">
                                <Label>{t('to')}</Label>
                                <Input size="sm" type="date" placeholder={t('to')} onChange={(e) => setFilterDateTovs2(e.target.valueAsDate)} />
                            </Col>
                            <Col md="6">
                                <Button block color="primary" onClick={updateVs}>{t('search')}</Button>
                            </Col>
                            <Col md="6" className="d-grid gap-2">
                                <ReactHTMLTableToExcel
                                    id="vsButton"
                                    className="btn btn-success btn-block"
                                    table="vsTable"
                                    filename="volumesPerSelf"
                                    sheet="volumes"
                                    buttonText="Excel"/>
                            </Col>
                            <Col md="12">
                                <hr />
                            </Col>
                        </Row>
                        <Table responsive id="vsTable">
                            <thead>
                                <tr className="bg-warning">
                                    <th>Πατάρι</th>
                                    <th>Ημερομηνία</th>
                                    <th>Αριθμός Όγκων</th>
                                    <th>Μ.Ο. Μήκους</th>
                                    <th>Μ.Ο. Πλάτους</th>
                                    <th>Μ.Ο. Ύψους</th>
                                    <th>Μ.Ο.Όγκου</th>
                                    <th>Μ.Ο. Βάρους</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    volumesPerDateAndSelf.map((a, i) => {
                                        return <tr key={i}>
                                            <td>{a.self}</td>
                                            <td>{a.date.split('T')[0].split('-').reverse().join('-')}</td>
                                            <td>{a.numVolumes}</td>
                                            <td>{a.length.toFixed(2)}</td>
                                            <td>{a.width.toFixed(2)}</td>
                                            <td>{a.height.toFixed(2)}</td>
                                            <td>{a.vol.toFixed(2)}</td>
                                            <td>{a.weight.toFixed(2)}</td>
                                        </tr>
                                    })
                                }
                                <tr>
                                    <th>Σύνολο</th>
                                    <td></td>
                                    <td>{volumesPerSelf.reduce((numVols, u) => numVols + parseInt(u.numVolumes), 0)}</td>
                                    
                                </tr>
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
                <hr />
            </Col>
            
        </Row>

    </Card>
}

export default withTranslation(Stats);